/**
 * 模块说明：折扣标记
 */
import { Service } from '@/tools'
export class DirectoryMarkServer<T extends TOrder.DirectoryMark> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.DirectoryMark}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  /**
   * 功能：查询所有折扣标记
   * /api/order/directoryMark/v1/queryMark
   */
   queryMark = <K extends T['ApiQueryMark']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryMark', data)

  /**
   * 功能：折扣标记分页
   * /api/order/directoryMark/v1/page
   */
   page = <K extends T['ApiPage']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

}
